<template>
    <div class="vertical-wrapper" style="height: 100%;"> 
        <router-view style="flex: 1 0 0;"></router-view>
        <md-bottom-bar style="flex: 0 0 auto; z-index:10" class="footer" md-type="shift"  :md-sync-route="true">
            <md-bottom-bar-item id="licenses" :to="{name:'licenses'}" md-label="Lizensen" :md-icon="require('../assets/sack-dollar-solid.svg')" ></md-bottom-bar-item>
            <md-bottom-bar-item id="qr-code-access" :to="{name:'qr-code-access'}" md-label="QR Code Zugang" :md-icon="require('../assets/qrcode-solid.svg')" ></md-bottom-bar-item>
            <md-bottom-bar-item id="demo-access" :to="{name:'demo-access'}" md-label="Demo Zugang" :md-icon="require('../assets/universal-access-solid.svg')"  ></md-bottom-bar-item>
            
            <md-bottom-bar-item id="user-activities" :to="{name:'user-activities'}" md-label="User Aktivität" :md-icon="require('../assets/chart-simple-solid.svg')" ></md-bottom-bar-item>
        
        
        </md-bottom-bar>
    </div>
</template>
<script>
export default {
    name: 'main-view'
}
</script>